/**
 * Date pickers follow the UI language: Czech uses cs, English uses en-GB
 * so that dates render as 7 October 2026 instead of the US order.
 */

import { ReactNode } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { cs } from "date-fns/locale/cs";
import { enGB } from "date-fns/locale/en-GB";
import { useTranslation } from ".";

export const DateLocalization = ({ children }: { children: ReactNode }) => {
  const { lang } = useTranslation();

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={lang === "en" ? enGB : cs}
    >
      {children}
    </LocalizationProvider>
  );
};
